import { createFileRoute, notFound } from '@tanstack/react-router';
import { ensurePublishedPrices } from '../../../features/catalog/queries';
import { EditorialPostPage } from '../../../features/editorial/EditorialPostPage';
import { articleHead } from '../../../features/editorial/articleHead';
import { NotFoundPage } from '../../../pages/NotFoundPage';
import { getAlternativeMeta, altUrl } from '../../../lib/alternatives/meta';
import { getAlternative } from '../../../lib/alternatives/posts';

export const Route = createFileRoute('/_site/alternatives/$slug')({
  staticData: { footer: 'slim' },
  // The published prices, so an article's `<Price>` tags render into the
  // prerendered HTML rather than after a browser fetch.
  loader: async ({ context, params }) => {
    const post = getAlternativeMeta(params.slug);
    if (!post) throw notFound();
    await ensurePublishedPrices(context.queryClient);
    return { fm: post.frontmatter, slug: post.slug };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { fm, slug } = loaderData;
    return articleHead(fm, altUrl(slug));
  },
  component: AlternativePostRoute,
});

function AlternativePostRoute() {
  const { slug } = Route.useParams();
  const post = getAlternative(slug);
  if (!post) return <NotFoundPage />;
  return (
    <EditorialPostPage
      post={post}
      canonicalUrl={altUrl(slug)}
      section={{
        name: 'Alternatives',
        href: '/alternatives',
        url: 'https://getanyapi.com/alternatives',
      }}
      heroAlt={`${post.frontmatter.competitor} vs AnyAPI`}
    />
  );
}
